import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "static-hero" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "static-body bg-gondola" }
const _hoisted_4 = {
  class: "container mw-1356",
  style: {"max-width":"860px"}
}
const _hoisted_5 = { class: "pp-section" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "pp-section" }
const _hoisted_8 = { class: "pp-section" }
const _hoisted_9 = { class: "pp-section" }
const _hoisted_10 = { class: "pp-section" }
const _hoisted_11 = { class: "pp-section" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "pp-section" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "top-title" }, "LEGAL", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Terms & Conditions", -1)),
        _createElementVNode("p", null, "The terms that govern your use of " + _toDisplayString(_ctx.c.tradingName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _cache[2] || (_cache[2] = _createTextVNode(" These Terms & Conditions (\"Terms\") form a binding agreement between you and ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.c.legalName), 1),
            (_ctx.c.registrationNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (registration no. " + _toDisplayString(_ctx.c.registrationNumber) + ")", 1))
              : _createCommentVNode("", true),
            _createTextVNode(", trading as " + _toDisplayString(_ctx.c.tradingName) + " (\"we\", \"us\"). By creating an account or making a payment you accept these Terms. ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", null, "1. The Service", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.c.tradingName) + " provides access to internet television (IPTV) streaming subscriptions. We grant you a personal, non-transferable, non-exclusive licence to access the service for the duration of your paid subscription. ", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[10] || (_cache[10] = _createElementVNode("h2", null, "2. Eligibility & Legal Restrictions", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _cache[4] || (_cache[4] = _createTextVNode("You must be at least ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.c.minAge) + " years old", 1),
              _cache[5] || (_cache[5] = _createTextVNode(" to purchase a subscription."))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("li", null, [
              _createTextVNode("The service is for "),
              _createElementVNode("strong", null, "private, personal, non-commercial use only"),
              _createTextVNode(". Public performance, redistribution, resale or sub-licensing of any content is prohibited.")
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("li", null, "You may not use the service to infringe any third party's intellectual property or to access content where you do not hold the necessary rights.", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("li", null, "Availability of specific channels and content may be subject to geographic licensing restrictions and can change without notice.", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("li", null, "You are responsible for complying with all laws and broadcasting regulations applicable in your country of residence.", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[17] || (_cache[17] = _createElementVNode("h2", null, "3. Subscriptions, Pricing & Billing", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _cache[11] || (_cache[11] = _createTextVNode("All prices are listed and charged in ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.c.payments.currency), 1),
              _cache[12] || (_cache[12] = _createTextVNode(". The exact amount and currency are shown before you confirm payment."))
            ]),
            _createElementVNode("li", null, [
              _cache[14] || (_cache[14] = _createTextVNode("Card payments are processed by our payment facilitator, ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.c.payments.facilitator.name), 1),
              (_ctx.c.payments.descriptor)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[13] || (_cache[13] = _createTextVNode(", and appear on your statement as ")),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.c.payments.descriptor), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _cache[15] || (_cache[15] = _createTextVNode("."))
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("li", null, "Subscriptions are prepaid for the selected term and activate once payment is confirmed.", -1)),
            _createElementVNode("li", null, "We accept " + _toDisplayString(_ctx.schemeList) + " and other methods shown at checkout.", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[22] || (_cache[22] = _createElementVNode("h2", null, "4. Refunds", -1)),
          _createElementVNode("p", null, [
            _cache[19] || (_cache[19] = _createTextVNode(" Refunds are governed by our ")),
            _createVNode(_component_RouterLink, { to: "/refund-policy" }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode("Return & Refund Policy")
              ])),
              _: 1
            }),
            _cache[20] || (_cache[20] = _createTextVNode(". In summary, you may request a refund within ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.c.refund.windowDays) + " days", 1),
            _cache[21] || (_cache[21] = _createTextVNode(" of purchase if the service cannot be made to work for you; see the full policy for eligibility and exclusions. "))
          ])
        ]),
        _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"pp-section\" data-v-1a8e25a0><h2 data-v-1a8e25a0>5. Account &amp; Security</h2><p data-v-1a8e25a0> You are responsible for keeping your account credentials and streaming details confidential. Sharing your subscription across multiple households or simultaneous unauthorised connections may result in suspension without refund. </p></div><div class=\"pp-section\" data-v-1a8e25a0><h2 data-v-1a8e25a0>6. Intellectual Property</h2><p data-v-1a8e25a0> All trademarks, logos and content remain the property of their respective owners. Nothing in these Terms transfers any ownership rights to you. </p></div><div class=\"pp-section\" data-v-1a8e25a0><h2 data-v-1a8e25a0>7. Suspension &amp; Termination</h2><p data-v-1a8e25a0> We may suspend or terminate your access if you breach these Terms, attempt fraud or chargebacks in bad faith, or misuse the service. Where termination is due to your breach, no refund is due. </p></div><div class=\"pp-section\" data-v-1a8e25a0><h2 data-v-1a8e25a0>8. Limitation of Liability</h2><p data-v-1a8e25a0> The service is provided &quot;as is&quot;. To the maximum extent permitted by law, our total liability for any claim is limited to the amount you paid for the subscription in the three months preceding the claim. We are not liable for interruptions caused by your internet connection, devices, or upstream content providers. </p></div>", 4)),
        _createElementVNode("div", _hoisted_11, [
          _cache[23] || (_cache[23] = _createElementVNode("h2", null, "9. Governing Law", -1)),
          (_ctx.hasJurisdiction)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, "These Terms are governed by the laws of " + _toDisplayString(_ctx.c.jurisdiction) + ".", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_13, "These Terms are governed by the laws of the country in which " + _toDisplayString(_ctx.c.tradingName) + " is established.", 1))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[30] || (_cache[30] = _createElementVNode("h2", null, "10. Business Details & Contact", -1)),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.c.legalName), 1),
            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.address), 1),
            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
            (_ctx.c.support.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                  _cache[24] || (_cache[24] = _createTextVNode("Email: ")),
                  _createElementVNode("a", {
                    href: 'mailto:' + _ctx.c.support.email
                  }, _toDisplayString(_ctx.c.support.email), 9, _hoisted_16)
                ]))
              : _createCommentVNode("", true),
            (_ctx.c.support.phone)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " · Phone: " + _toDisplayString(_ctx.c.support.phone), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", null, [
            _cache[28] || (_cache[28] = _createTextVNode("For any questions, visit our ")),
            _createVNode(_component_RouterLink, { to: "/contact-us" }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("Contact Us")
              ])),
              _: 1
            }),
            _cache[29] || (_cache[29] = _createTextVNode(" page."))
          ])
        ])
      ])
    ]),
    _createVNode(_component_CopyRight)
  ]))
}